<template>
  <mcs-image-card
    class="greyLight"
    :url="part.imageUrl"
    thumbnail
    imageBackgroundColor="white"
    imgMaxWidth="50"
    :title="promo_product.name"
  >
    <div><b>Quantity:</b> {{ edit_item.quantity }}</div>
    <div><b>Color:</b> {{ part.colorName }}</div>
    <template v-if="edit_item.isDecorated">
      <div><b>Location: </b> {{ location.name }}</div>
      <div><b>Decoration:</b> {{ decoration.name }} ({{ decoration_color.name }})</div>
    </template>
    <div class="mt-2">
      <mcs-chip
        append-icon="mdi-pencil"
        color="white"
        outlined
        @click="$emit('edit')"
      >
        Edit
      </mcs-chip>
    </div>
  </mcs-image-card>
</template>

<script>
import promo from '@/utils/mixins/promo';
import { mapGetters } from 'vuex';

export default {
  components: {},

  mixins: [promo],

  data: () => ({ store: 'printcart' }),

  computed: {
    edit_item: {
      get() {
        return this.$store.getters['printcart/edit_item'];
      },
      set(val) {
        this.$store.dispatch('printcart/setEditItem', val);
      }
    },

    ...mapGetters({})
  },

  created() {},

  methods: {}
};
</script>

<style scoped></style>
